import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import dayjs from "dayjs";

const rupiah = (value) => `Rp. ${(Number(value) || 0).toLocaleString("id-ID")}`;

const headTable = () => {
  return [
    {
      no: "No.",
      created_at: "Tanggal Input",
      oid: "No. Order",
      client_name: "Pelanggan",
      item_name: "Nama Item",
      qty: "Qty",
      base_price: "Harga Kulak",
      total_base_price: "Total Kulak",
      selling_price: "Harga Jual",
      total_sales: "Total Jual",
      total_profit: "Laba",
    },
  ];
};

const ProfitItemReportPDF = (data, year, clientName) => {
  let doc = new jsPDF({
    putOnlyUsedFonts: true,
    orientation: "landscape",
    format: [210, 330],
  });

  /* GROUP ROWS PER TRANSAKSI (ORDER) */
  const groups = [];
  let current = null;
  data.forEach((x) => {
    if (!current || current.order_id !== x.order_id) {
      current = { order_id: x.order_id, items: [] };
      groups.push(current);
    }
    current.items.push(x);
  });

  let result = [];

  const headerStyle = {
    halign: "left",
    valign: "middle",
    fontStyle: "bold",
    fillColor: [226, 235, 248],
  };

  groups.forEach((group, gi) => {
    const order = group.items[0];
    const orderDate = order.created_at
      ? dayjs(order.created_at).format("DD-MM-YYYY")
      : "-";

    result.push([
      { content: `${gi + 1}.`, styles: headerStyle },
      { content: orderDate, styles: headerStyle },
      { content: order.oid, styles: headerStyle },
      { content: order.client_name || "-", styles: headerStyle },
      {
        content: order.invoice_number
          ? `No. Nota: ${order.invoice_number}`
          : "",
        colSpan: 7,
        styles: headerStyle,
      },
    ]);

    group.items.forEach((x) => {
      result.push([
        { content: x.item_name, colSpan: 5 },
        { content: x.qty, styles: { halign: "right" } },
        { content: rupiah(x.base_price), styles: { halign: "right" } },
        { content: rupiah(x.total_base_price), styles: { halign: "right" } },
        { content: rupiah(x.selling_price), styles: { halign: "right" } },
        { content: rupiah(x.total_sales), styles: { halign: "right" } },
        { content: rupiah(x.total_profit), styles: { halign: "right" } },
      ]);
    });

    const sub_total_base_price = group.items.reduce(
      (n, x) => Number(n) + (Number(x.total_base_price) || 0),
      0
    );
    const sub_total_sales = group.items.reduce(
      (n, x) => Number(n) + (Number(x.total_sales) || 0),
      0
    );
    const sub_total_profit = group.items.reduce(
      (n, x) => Number(n) + (Number(x.total_profit) || 0),
      0
    );

    result.push([
      {
        content: "Total Transaksi",
        colSpan: 7,
        styles: { halign: "center", valign: "middle", fontStyle: "bold" },
      },
      {
        content: rupiah(sub_total_base_price),
        styles: { halign: "right", fontStyle: "bold" },
      },
      {
        content: "",
        styles: { fontStyle: "bold" },
      },
      {
        content: rupiah(sub_total_sales),
        styles: { halign: "right", fontStyle: "bold" },
      },
      {
        content: rupiah(sub_total_profit),
        styles: { halign: "right", fontStyle: "bold" },
      },
    ]);
  });

  const grand_total_base_price = data?.reduce(
    (n, { total_base_price }) => Number(n) + (Number(total_base_price) || 0),
    0
  );
  const grand_total_sales = data?.reduce(
    (n, { total_sales }) => Number(n) + (Number(total_sales) || 0),
    0
  );
  const grand_total_profit = data?.reduce(
    (n, { total_profit }) => Number(n) + (Number(total_profit) || 0),
    0
  );

  if (!result.length) {
    result = [
      [
        {
          content: "Tidak ada data",
          colSpan: 11,
          styles: { halign: "center", valign: "middle", fontStyle: "bold" },
        },
      ],
    ];
  }

  const gt = [
    [
      {
        content: "Total",
        colSpan: 7,
        styles: { halign: "center", valign: "middle", fontStyle: "bold" },
      },
      {
        content: rupiah(grand_total_base_price),
        styles: { halign: "right", fontStyle: "bold" },
      },
      {
        content: "",
        styles: { fontStyle: "bold" },
      },
      {
        content: rupiah(grand_total_sales),
        styles: { halign: "right", fontStyle: "bold" },
      },
      {
        content: rupiah(grand_total_profit),
        styles: { halign: "right", fontStyle: "bold" },
      },
    ],
  ];

  doc.setFontSize(10);
  doc.setFont("times", "bold");
  doc.text("Laporan Laba Per Item", 14, 10);
  doc.text(`Tahun ${year}`, 14, 15);
  doc.text(`Nama Pelanggan: ${clientName}`, 14, 20);

  autoTable(doc, {
    startY: 23,
    theme: "grid",
    headStyles: { fillColor: [47, 84, 150], textColor: "white" },
    head: headTable(),
    body: [...result, ...gt],
    columnWidth: "wrap",
    tableWidth: "auto",
    styles: {
      overflow: "linebreak",
      overflowColumns: "linebreak",
      textColor: "black",
      fontSize: 8,
    },
    columnStyles: {
      qty: { halign: "right" },
      base_price: { halign: "right" },
      total_base_price: { halign: "right" },
      selling_price: { halign: "right" },
      total_sales: { halign: "right" },
      total_profit: { halign: "right" },
    },
  });

  doc.setProperties({
    title: "Laporan Laba Per Item",
  });

  window.open(
    doc.output("bloburl", {
      filename: "Laporan Laba Per Item.pdf",
    })
  );
};

export default ProfitItemReportPDF;
